import environment from '#/environment/environment';
import {Chain} from 'viem';
import {mainnet} from 'viem/chains';

export const getHttpTransportUrl = (chain: Chain) => {
  if (environment.alchemyHttpsUrl && chain.id !== mainnet.id) {
    return environment.alchemyHttpsUrl;
  }

  return chain.rpcUrls.default.http[0];
};

export const getHttpTransportUrls = (chain: Chain) => {
  if (environment.alchemyHttpsUrl && chain.id !== mainnet.id) {
    return [
      chain.rpcUrls.default.http[0],
      'https://rpc-amoy.polygon.technology',
      'https://polygon-amoy.drpc.org',
      'https://api.zan.top/polygon-amoy',
      'https://polygon-amoy.gateway.tenderly.co',
      environment.alchemyHttpsUrl,
    ];
  }

  return [chain.rpcUrls.default.http[0]];
};
